import React from 'react';
import NewBadge from '@wix/da-ds/pkg/Badges/NewBadge';
import s from './StandardMenuItemLabel.scss';
const StandardMenuItemLabel = ({ item: { label , complexLabel , newTag  }  })=>{
    // allows some items to separate visually their text label from option label
    if (complexLabel) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, complexLabel);
    }
    return typeof label === 'string' ? /*#__PURE__*/ React.createElement("span", {
        className: s['menu-item-text-label']
    }, label, newTag ? /*#__PURE__*/ React.createElement(NewBadge, {
        className: s['menu-item-new-tag']
    }) : null) : /*#__PURE__*/ React.createElement(React.Fragment, null, label);
};
StandardMenuItemLabel.displayName = 'StandardMenuItemLabel';
export default StandardMenuItemLabel;
